/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import "./KeyValueDisplay.css";
import PropTypes from "prop-types";

/**
 * This component takes in a label and react node and displays the twoside by side eg(label : node).
 * it also takes in a variable declaring whether or not the node should attempt to be displayed on the same line.
 * @param {Object} props The object containing the label, node, and row properties passed in.
 * @param {string} props.label The label for the Key value display.
 * @param {node} props.node The Value for the display item. Can be anything.
 * @param {boolean} props.row A boolean that denotes whether or not the display should be in a single row.
 */
const KeyValueDisplay = ({ label, node, row }) => {
	const display = row ? "inline" : "block";

	return (
		<span data-testid="key-value-display" style={{ wordBreak: "break-all" }}>
			<div
				style={{ display, marginRight: row ? "5px" : "0px" }}
				className="key-value-display-label"
				data-testid="key-value-display-label"
			>
				{label}:
			</div>
			<div style={{ display }} className="key-value-display-node" data-testid="key-value-display-node">
				{node}
			</div>
		</span>
	);
};

KeyValueDisplay.propTypes = {
	label: PropTypes.string.isRequired,
	node: PropTypes.node.isRequired,
	row: PropTypes.bool.isRequired,
};

export default KeyValueDisplay;
